import { Button, Card, Col, Flex, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatDate } from "utils/formatter";
import dayjs from "dayjs"
import { useEffect } from "react";

const CreateProjectInformation = ({
    onSubmit = () => { },
    employeeOptions = [],
    PROJECT_STATUS = [],
    project = {},
    isView = false,
    isEdit = false
}) => {
    const { t, i18n } = useTranslation();
    const [form] = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        form.setFieldsValue({
            ...project, startDate: dayjs(project?.startDate),
            endDate: dayjs(project?.endDate),
            ownerListId: project?.ownerLists?.[0]?.id,
            forAll: project?.forAll === "Y" ? true : false
        })
    }, [project, form])

    return (
        <Card style={{
            backgroundColor: "white",
            width: "100%",
            boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
            borderRadius: "20px"
        }}
        >
            <FormAntd
                form={form}
                onFinish={() => {
                    onSubmit(form.getFieldsValue(true))
                    form.resetFields()
                }}
            >
                <FormItem shouldUpdate={(prev, curv) => prev.forAll !== curv.forAll}>
                    {({ getFieldsValue, getFieldValue, setFieldValue, resetFields }) => {
                        return (
                            <Space size={16} direction="vertical" style={{ width: "100%" }}>
                                <Row justify={"space-between"}>
                                    <Col span={8}>
                                        <FormInput
                                            name="projectCode"
                                            label={t("setting_project.label.projectId")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>

                                    {/* <Col span={15}>
                                        <FormInput
                                            name="projectName"
                                            label={t("setting_project.label.projectName")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col> */}
                                    <Col span={7}>
                                        <FormInput
                                            name="projectName"
                                            label={t("setting_project.label.projectName")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>

                                    <Col span={7}>
                                        <FormInput
                                            name="projectNameEn"
                                            label={t("setting_project.label.projectNameEn")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>
                                </Row>
                                {/* <Row justify={"space-between"}>
                                    <Col span={11}>
                                        <FormInput
                                            name="projectName"
                                            label={t("setting_project.label.projectName")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>

                                    <Col span={11}>
                                        <FormInput
                                            name="projectNameEn"
                                            label={t("setting_project.label.projectNameEn")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>
                                </Row> */}

                                <Row justify={"space-between"}>
                                    <Col span={8}>
                                        <FormSelect
                                            name="ownerListId"
                                            label={t("setting_project.label.responsiblePerson")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            options={employeeOptions}
                                            disabled={getFieldValue("forAll") === true || getFieldValue("forAll") === "Y" || isView}
                                            required
                                        />
                                    </Col>

                                    <Col span={7}>
                                        <FormDatePicker
                                            name="startDate"
                                            label={t("start-date")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            dateFormat={formatDate()}
                                            required
                                            disabled={isView}
                                        />
                                    </Col>
                                    <Col span={7}>
                                        <FormDatePicker
                                            name="endDate"
                                            label={t("end-date")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            dateFormat={formatDate()}
                                            required
                                            disabled={isView}
                                        />
                                    </Col>
                                </Row>

                                <Row justify={"space-between"}>
                                    <Col span={8}>
                                        <FormInput
                                            name="manDay"
                                            label={t("setting_project.label.man_day")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>

                                    <Col span={7}>
                                        <FormInput
                                            name="costCenter"
                                            label={t("setting_project.label.cost_center")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            disabled={isView}
                                        />
                                    </Col>
                                    <Col span={7}>
                                        <FormSelect
                                            name="projectStatus"
                                            label={t("setting_project.label.project_status")}
                                            placeholder={t("common.pleaseSelect")}
                                            options={PROJECT_STATUS}
                                            size="large"
                                            required
                                            disabled={isView}
                                        />
                                    </Col>
                                </Row>

                                <Col span={24}>
                                    <FormInput
                                        name="description"
                                        label={t("employee.label.description")}
                                        placeholder={t("common.explain_further")}
                                        size="large"
                                        required
                                        type="textArea"
                                        rows={2}
                                        disabled={isView}
                                    />
                                </Col>

                                <Flex gap={16} align="center">
                                    <FormSwitch name="forAll" disabled={isView || isEdit} onChange={(e) => {
                                        form.setFieldValue("forAll", e)
                                    }} />
                                    <span>{t("setting_project.label.for_all")}</span>
                                </Flex>
                                {
                                    isView ? (
                                        <>
                                            <Row justify="end" style={{ gap: "12px", paddingTop: "48px" }}>
                                                <Button type="default"
                                                    style={{ height: "40px", borderRadius: "8px", color: "#565656" }}
                                                    onClick={() => {
                                                        resetFields()
                                                        form.resetFields()
                                                        navigate("/setting_timesheet/setting_project")
                                                    }}
                                                >
                                                    {t("common.back").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </>
                                    ) : (
                                        <>
                                            <Row justify="end" style={{ gap: "12px", paddingTop: "48px" }}>
                                                <Button type="default"
                                                    style={{ height: "40px", borderRadius: "8px", color: "#565656" }}
                                                    onClick={() => {
                                                        resetFields()
                                                        form.resetFields()
                                                        navigate("/setting_timesheet/setting_project")
                                                    }}
                                                >
                                                    {t("common.cancel").toUpperCase()}
                                                </Button>

                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white" }}
                                                >
                                                    {t("common.submit").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </>
                                    )

                                }

                            </Space>
                        )
                    }}
                </FormItem>
            </FormAntd>
        </Card >
    )
}

export default CreateProjectInformation;